module.exports = __webpack_public_path__ + "img/garcon.e1f98c71.png";